import service from '@/http/HttpInterceptor.js'
import API_LIST from '@/api/config'
/**
 * 获取session信息
 *
 */
export const getArticleList = (params) => {
  return service({
    url: API_LIST.works.list,
    method: 'post',
    data: params
  })
}

export default Object.assign({
  getArticleList
})



// WEBPACK FOOTER //
// ./src/api/interface/works.js